
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import getContractorsMultiselectConditions from "@/helpers/getContractorsMultiselectConditions";

import InputRangeFilter from "@/components/filters/InputRangeFilterNew.vue";
import FiltersContainer from "@/components/filters/filters-container.vue";
import UiButton from "@/components/button/ui-button.vue";
import DateFilterContainer from "@/components/filters/DateFilterContainerNew.vue";
import ContractorsMultiselect from "@/components/autocompleteMultiselects/ContractorsMultiselectNew.vue";
import ManagersMultiselect from "@/components/autocompleteMultiselects/ManagersMultiselectNew.vue";
import UIButton from "@/components/button/ui-button.vue";
import FormGroup from "@/components/form/FormGroupNew.vue";
import ProfileCountrySelect from "@/components/autocompleteMultiselects/ProfileCountrySelectNew.vue";
import UserCitiesMultiNew from "@/components/autocompleteMultiselects/UserLocationsMultiNew.vue";

import Roles from "@/entities/Roles";
import DropdownOption from "@/entities/DropdownOption";
import ProjectsFiltersQuery from "@/entities/filters/ClientsFiltersQuery";
import ProjectCityMultiselect from "@/components/autocompleteMultiselects/ProjectCityMultiselectNew.vue";
import isCountryUSAHelper from "@/helpers/locations/isCountryUsa";
import isValuePresent from "@/helpers/isValuePresent";
import getMultiselectValues from "@/helpers/multiselect/getMultiselectValues";
import getStateProvinceSelectTitle from "@/helpers/locations/getStateProvinceSelectTitle";
import RegionInput from "@/components/autocompleteMultiselects/RegionInputCustom.vue";
import UiButtonMessage from "@/components/button/ui-button-message.vue";
import FormDatepicker from "../form/FormDatepickerV2.vue";

@Component({
  components: {
    RegionInput,
    UiButton,
    InputRangeFilter,
    FiltersContainer,
    DateFilterContainer,
    ProjectCityMultiselect,
    ContractorsMultiselect,
    ManagersMultiselect,
    FormGroup,
    UIButton,
    UserCitiesMultiNew,
    ProfileCountrySelect,
    UiButtonMessage,
    FormDatepicker,
  },
})
export default class ClientsVisitsCollectionFilters extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly hideManagersFilter!: boolean;
  @Prop({ type: Boolean, default: false })
  readonly hideContractorsFilter!: boolean;
  @Prop({ type: Boolean, default: false })
  readonly isDateOffered!: boolean;
  @Prop({ type: Boolean, default: false })
  readonly hideBudgetFilter!: boolean;
  @Prop({ type: String, default: undefined }) readonly currentUserId?: string;
  @Prop({ type: String, default: undefined })
  readonly currentUserRole?: string;
  @Prop({ type: Object, required: true })
  readonly filters!: ProjectsFiltersQuery;

  client_name: string = "";
  location: string = "";
  countries: DropdownOption[] = [];
  states: DropdownOption[] = [];
  cities: DropdownOption[] = [];
  contractorsIds: string[] = [];
  managersIds: string[] = [];
  minBudget: string = "";
  maxBudget: string = "";
  contractorUpdatedAt: string = "";
  endDate: string = "";

  get countryName(): string {
    return this.countries[0]?.name || "";
  }
  handleUpdate(date) {
    this.contractorUpdatedAt = date;
  }
  get isCountrySpecified(): boolean {
    return this.countries.length == 1 && isValuePresent(this.countryName);
  }

  get isCountryUSA(): boolean {
    return isCountryUSAHelper(this.countryName);
  }

  get countriesNames(): string[] {
    return this.countries.map((country) => country.name);
  }

  get statesNames(): string[] {
    return this.states.map((state) => state.name);
  }

  get citiesNames(): string[] {
    return this.cities.map((city) => city.name);
  }

  get propToWatch(): String {
    return JSON.stringify([
      this.client_name,
      this.location,
      this.minBudget,
      this.maxBudget,
      this.contractorUpdatedAt,
      this.endDate,
      this.contractorsIds,
      this.countriesNames,
      this.statesNames,
      this.citiesNames,
      this.managersIds,
    ]);
  }

  get contractorsMultiselectConditions(): Object | undefined {
    return getContractorsMultiselectConditions(this.currentUserRole);
  }

  get managersMultiselectConditions(): Object | undefined {
    if (this.currentUserRole !== Roles.CONTRACTOR) {
      return {};
    }

    return {
      projects: {
        project_activities: {
          contractor: {
            user_id: {
              _eq: this.currentUserId,
            },
          },
        },
      },
    };
  }

  @Watch("filters", { immediate: true })
  updateFiltersValues(): void {
    this.client_name = this.filters.client_name;
    this.location = this.filters.location;
    this.contractorsIds = this.filters.contractors;
    this.managersIds = this.filters.managers;
    this.contractorUpdatedAt = this.filters.contractorUpdatedAt;
  }

  @Watch("propToWatch")
  handlePropToWatchChange(): void {
    const dateFormat = "YYYY-MM-DD";

    this.$emit("filtersChanged", {
      endDate: this.endDate
        ? this.$moment(this.endDate).format(dateFormat)
        : "",
      contractorUpdatedAt: this.contractorUpdatedAt
        ? this.$moment(this.contractorUpdatedAt).format(dateFormat)
        : "",
      client_name: this.client_name,
      location: this.location,
      minBudget: this.minBudget,
      maxBudget: this.maxBudget,
      contractors: this.contractorsIds,
      managers: this.managersIds,
      countries: this.countriesNames,
      states: this.statesNames,
      cities: this.citiesNames,
    });
  }

  handleReset(): void {
    this.contractorUpdatedAt = null;
  this.client_name = "";
  this.location = "";
  this.contractorsIds = [];
  this.managersIds = [];
  this.minBudget = null;
  this.maxBudget = null;
  this.$emit("filtersReset");
  }
}
